import { useEffect, useRef, useState } from 'react';
import { useGetMyApprovedTrades } from 'api/queries/trades/get-my-approved-trades';
import { useModals } from 'providers/Modals';
import { useAppState } from 'providers/AppState';

const CHECK_INTERVAL = 15000; //ms

export default function useWatchMyApprovedTrades() {
  const { open, openedModal } = useModals();
  const [trigger, setTrigger] = useState(false);

  const { blockRequests } = useAppState();

  const seenTradeIds = useRef<Set<string>>(new Set());
  const initialized = useRef(false);

  const { data, refetch } = useGetMyApprovedTrades(openedModal !== 'trade-approved-notification');

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    if (!data || blockRequests) {
      return () => {
        if (timeout !== null) clearTimeout(timeout);
      };
    }

    refetch()
      .then(({ data: result }) => {
        if (!result) return;

        if (!initialized.current) {
          initialized.current = true;
          result.forEach((item) => {
            seenTradeIds.current.add(item.data.id);
          });
          return;
        }

        const newTrade = result.find((item) => !seenTradeIds.current.has(item.data.id));
        if (newTrade) {
          seenTradeIds.current.add(newTrade.data.id);
          open('trade-approved-notification', { tradeId: newTrade.data.id, tradeCode: newTrade.data.code });
        }
      })
      .catch(console.error)
      .finally(() => {
        timeout = setTimeout(() => {
          setTrigger((prev) => !prev);
        }, CHECK_INTERVAL);
      });

    return () => {
      if (timeout !== null) clearTimeout(timeout);
    };
  }, [data, trigger, blockRequests, refetch, open]);
}
